import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const getSystemPreference = () => {
    if (typeof window !== 'undefined' && window.matchMedia) {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
};

const useThemeStore = create(
    persist(
        (set, get) => ({
            mode: 'light',
            setMode: (mode) => {
                if (mode === 'dark' || mode === 'light') {
                    set({ mode });
                }
            },
            toggleMode: () => {
                set((state) => ({ mode: state.mode === 'dark' ? 'light' : 'dark' }));
            },
            initialize: () => {
                const stored = localStorage.getItem('theme-mode');
                if (!stored) {
                    set({ mode: 'light' });
                }
            },
        }),
        {
            name: 'theme-mode',
            partialize: (state) => ({ mode: state.mode }),
        },
    ),
);

if (typeof window !== 'undefined' && window.matchMedia) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleSystemPreferenceChange = (e) => {
        const store = useThemeStore.getState();
        const stored = localStorage.getItem('theme-mode');
        if (!stored || stored === 'null') {
            store.setMode(e.matches ? 'dark' : 'light');
        }
    };

    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleSystemPreferenceChange);
    } else if (mediaQuery.addListener) {
        mediaQuery.addListener(handleSystemPreferenceChange);
    }
}

export default useThemeStore;
